module.exports = __webpack_public_path__ + "static/media/sine1kHz.55662432.mp3";